/* import __COLOCATED_TEMPLATE__ from './version-dropdown-data-note.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();